import React, { useEffect, useState } from 'react'
import teacher from "../imgs/teacher.png"
import { Button, Form, Row, Col } from "react-bootstrap"
import Fade from 'react-reveal/Fade';
import InputField from '../components/InputField';
import { useStateMachine } from "little-state-machine";
import { useForm } from "react-hook-form";
import updateAction from "../updateAction";
import * as yup from "yup";
import { Navigate } from "react-router-dom";
import { yupResolver } from "@hookform/resolvers/yup"
import { Helmet } from 'react-helmet'
import Success from '../components/Success';
import Failure from '../components/Failure';
import { Audio, Circles, Grid, TailSpin } from 'react-loader-spinner'

const Sfinal = (props) => {
    function convetToTimestap(date) {
        if (date != undefined)
            return date.getTime() / 1000;
    }

    const { state, actions } = useStateMachine({ updateAction });
    const [go, setgo] = useState(false);
    const [msg, setmsg] = useState();
    const [GT, setGT] = useState(null);
    const [isLoading, setisLoading] = useState(true);
    const [Error,setError] = useState(false);
    const [msgs, setmsgs] = useState([]);

     useEffect(() => {
         if (!state.dob) {
             setgo(true);
         }
     });
    useEffect(() => {
        getResponse();
    }, []);

    function getResponse() {
        let url = "https://cbistt.com/appserver/addaccount";
        if (!state.SpouseName) {
            state["SpouseName"] = "";
        }
        if (!state.courses) {
            state["courses"] = "";
        }
        var userdata = JSON.stringify({
            "username": state.username,
            "password": state.password,
            "firstname": state.firstname,
            "lastname": state.surname,
            "email": state.email,
            "city": state.city,
            "customprofilefields[0][type]": "string",
            "customprofilefields[0][name]": "profile_field_Church",
            "customprofilefields[0][value]": state.church,
            "customprofilefields[1][type]": "string",
            "customprofilefields[1][name]": "profile_field_DOB",
            "customprofilefields[1][value]": convetToTimestap(state.dob),
            "customprofilefields[2][type]": "string",
            "customprofilefields[2][name]": "profile_field_Saved",
            "customprofilefields[2][value]": state.saved,
            "customprofilefields[3][type]": "string",
            "customprofilefields[3][name]": "profile_field_Sex",
            "customprofilefields[3][value]": state.Gender,
            "customprofilefields[4][type]": "string",
            "customprofilefields[4][name]": "profile_field_phone_no",
            "customprofilefields[4][value]": state.Phone,
            "customprofilefields[5][type]": "string",
            "customprofilefields[5][name]": "profile_field_Marital",
            "customprofilefields[5][value]": state.marry,
            "customprofilefields[6][type]": "string",
            "customprofilefields[6][name]": "profile_field_born_again",
            "customprofilefields[6][value]": convetToTimestap(state.DOBSpirit),

            "customprofilefields[7][type]": "string",
            "customprofilefields[7][name]": "profile_field_Ministry",
            "customprofilefields[7][value]": state.Ministry,

            "customprofilefields[8][type]": "string",
            "customprofilefields[8][name]": "profile_field_Ministry_Involvement",
            "customprofilefields[8][value]": state.MinistryInvolvement,

            "customprofilefields[9][type]": "string",
            "customprofilefields[9][name]": "profile_field_Pastor",
            "customprofilefields[9][value]": state.PastorName,

            "customprofilefields[10][type]": "string",
            "customprofilefields[10][name]": "profile_field_Qualifications",
            "customprofilefields[10][value]": state.Qualifications,

            "customprofilefields[11][type]": "string",
            "customprofilefields[11][name]": "profile_field_Spouse",
            "customprofilefields[11][value]": state.SpouseName,

            "customprofilefields[12][type]": "string",
            "customprofilefields[12][name]": "profile_field_born_experience",
            "customprofilefields[12][value]": state.Testimony,

            "customprofilefields[13][type]": "string",
            "customprofilefields[13][name]": "profile_field_Baptism",
            "customprofilefields[13][value]": convetToTimestap(state.bapDate),

            "customprofilefields[14][type]": "string",
            "customprofilefields[14][name]": "profile_field_Address",
            "customprofilefields[14][value]": state.address,

            "customprofilefields[15][type]": "string",
            "customprofilefields[15][name]": "profile_field_children",
            "customprofilefields[15][value]": state.childnNum,

            "customprofilefields[16][type]": "string",
            "customprofilefields[16][name]": "profile_field_church_membership",
            "customprofilefields[16][value]": state.churchtime,

            "customprofilefields[17][type]": "string",
            "customprofilefields[17][name]": "profile_field_complete_registration",
            "customprofilefields[17][value]": state.complete,

            "customprofilefields[18][type]": "string",
            "customprofilefields[18][name]": "profile_field_short_courses",
            "customprofilefields[18][value]": state.courses,
            "profile_pic": state.base64Photo
        });
        console.log("userdata ", userdata);
        var requestOptions = {
            method: 'POST',
            redirect: 'follow',
            body: userdata,
            headers: {
                'Content-Type': 'application/json'
            },
        };

        fetch(url, requestOptions)
            .then(response => response.text())
            .then(result => handleResponse(result))
            .catch(error => {
                console.log('error', error);
                setError(true);
                setisLoading(false);
            });
    }

    function handleResponse(response) {
        console.log(response);
        var arr = [];
        var obj = JSON.parse(response);
        console.log("obj ", obj);
        setGT(obj.success);
        if (obj.warnings) {
            for (let warn of obj.warnings) {
                arr.push(warn["message"])
            }
            setmsgs(arr);
            console.log(msgs);
        }
        if (obj.success) {
            setmsg("Success")
        } else {
            setmsg("Falure");
        }
        setisLoading(false);
    }

    return (

        <>
            <Helmet>
                <title>Registration</title>
            </Helmet>
            {go && (
                <Navigate to='/Sstep1' />
            )}
            <div className="bg"></div>
            <div className="bg bg2"></div>
            <div className="bg bg3"></div>
            {/* <div className="content"> */}

            <div className="container1">

                <div className="wrapper1">
                    <ul className="steps">
                        <li className="is-active">Step 7</li>
                    </ul>
                    <form className="form-wrapper1" >

                        <fieldset className="section is-active">
                            <Fade>
                                <>
                                   <h3>Welcome, {state.firstname}</h3>

                                    {msg}<br />
                                    {isLoading && (
                                        <Fade>
                                            <div className='d-flex justify-content-center align-items-center'>
                                                <TailSpin
                                                    height="80"
                                                    width="80"
                                                    radius="9"
                                                    color='#0f8fff'
                                                    ariaLabel='three-dots-loading'
                                                    wrapperStyle
                                                    wrapperClass
                                                />
                                            </div>
                                            <p style={{marginTop:"20px"}}>Uploading Image... this might take a while</p>
                                        </Fade>
                                    )}
                                    {/* GT is short for get through... also meaning that the request was successful */}
                                    {!isLoading && GT == true && (<>
                                        <Success /> <br />
                                        <p>You have successfully signed up please check your email address <b>{state.email}</b> to confirm your account</p>
                                    </>)
                                    }
                                    {!isLoading && GT == false && (<>
                                        <Failure />
                                        {msgs.map(m => <p>{m}</p>)}
                                        <p><b>You might need to refresh the form and start over</b></p>
                                    </>
                                    )}
                                    {!isLoading && Error && (<><p>Sorry,something went wrong please try again</p></>)}
                                </>
                            </Fade>
                        </fieldset>
                    </form>
                </div>
            </div>


            {/* </div> */}
        </>
    )
}

// {"success":false,"warnings":[{"item":"username","itemid":0,"warningcode":"fielderror","message":"This username already exists, choose another"},{"item":"email","itemid":0,"warningcode":"fielderror","message":"This email address is already registered. Perhaps you created an account in the past? &lt;a href=&quot;https:\/\/cbistt.com\/login\/forgot_password.php&quot;&gt;Recover forgotten username or password&lt;\/a&gt;"}]}

export default Sfinal
